<!--
	描述：弹窗树
-->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body" :msvalue='msStyle'>
		<template slot="title">
			{{title}}
		</template>
		<archivesTree :target="target" ref="tree" :checked="true" @checkItem="nowEntity = $event" class="entityTree"></archivesTree>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	import archivesTree from '@/components/module/tree/archivesTree.vue'
	import resourcesStore from '../../../cache/resourcesStore.js'
	export default {
		components: {
			dialogBody,
			archivesTree,
		},
		props: [],
		data() {
			return {
				target:undefined,
				nowEntity: undefined,
				title:'',
				callback:undefined
			}
		},
		computed: {
			msStyle(){
				return  {
					'color': this.getColorById('fontColor'),
					'background-color': this.getColorById('secondMenuBG'),
					'border': '1px solid #D6D6D6',
					'min-height': '1rem',
					'max-height': '3rem',
					'padding': '.1rem',
					'overflow-y': 'auto',
				}
			}
		},
		watch: {},
		mounted() {},
		methods: {
			getColorById(id){
				return resourcesStore.getters.getColorById(id)
			},
			confirm(){
				var shouleClose = true
				if(this.callback != undefined) {
					shouleClose = this.callback(this.nowEntity)
				}
				if(shouleClose != false) {
					this.$refs.body.close()
					this.result = {}
				}
			},
			cancel(){
				this.close()
			},
			open(title,target,callback,treeType){
				//targetId
				this.target = target
				this.title = title
				this.callback = callback
				this.$refs.body.open()
			},
			close(){
				this.$refs.body.hide()
			},
		}
	}
</script>
<style scoped>
	.addDialogBody{
		display: flex;
		align-items: center;
		height: .4rem;
		line-height: .4rem;
		justify-content: center;
	}
	.addDialogBody>span{
	}
	.addDialogBody>input{
		border: .01rem solid #A9A9A9;
		border-radius: .05rem;
		margin-left: .2rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		width: 2rem;
	}
</style>